/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { ACTION_TYPES } from "../constants";

const useActionTypes = ({
    setMustConfirm
}) => {
    //#region States
    const [actionTypeList, setActionTypeList] = useState([]);
    const [actionTypeOfNoActionForHaveAttendanceOrPenalty, setActionTypeOfNoActionForHaveAttendanceOrPenalty] = useState(0);
    //#endregion
    //#region Effects
    useEffect(() => {
        setMustConfirm(actionTypeList.length > 0);
    }, [actionTypeList]);
    //#endregion
    //#region Functions
    const addActionType = actionType => {
        if (!actionTypeList.includes(actionType)) 
            setActionTypeList([...actionTypeList, actionType].sort());
    }
    const removeActionType = actionType => {
        setActionTypeList(prev => prev.filter(currentActionType => currentActionType !== actionType));
    }
    const getActionNameList = actionListTypes => {
        return actionListTypes.map(action => Object.entries(ACTION_TYPES).find(([_, value]) => value === action)[0]);
    }
    function noActions() {
        return actionTypeList.length === 0;
    }
    //#endregion
    return {
        actionTypeList: {
            value: actionTypeList,
            add: addActionType,
            remove: removeActionType,
            noActions,
            getNameList: getActionNameList
        },
        actionTypeOfNoActionForHaveAttendanceOrPenalty: {
            value: actionTypeOfNoActionForHaveAttendanceOrPenalty,
            set: setActionTypeOfNoActionForHaveAttendanceOrPenalty
        }
    };
}	
    
export default useActionTypes;